const AllCollectionData = [
  {
    img: "property/grid-one.jpg",
    location: "35-A Jalan Ss 22/19 Damansara Jaya",
    priceInRM: 3330020,
    price: 234,
    bed: 4,
    bath: 2,
    btn_link: "/booked-prop-details",
  },
  {
    img: "property/grid-two.jpg",
    location: "8706 Herrick Ave, Negeria Sembilan",
    priceInRM: 3330020,
    price: 654,
    bed: 4,
    bath: 2,
    btn_link: "/booked-prop-details",
  },
  {
    img: "property/grid-three.jpg",
    location: "9806 johar Ave, Nasa City Johar",
    priceInRM: 3330020,
    price: 214,
    bed: 4,
    bath: 2,
    btn_link: "/booked-prop-details",
  },
  {
    img: "property/grid-four.jpg",
    location: "No. 9 Jalan Tp 7, Uep Industrial Park",
    priceInRM: 3330020,
    price: 234,
    bed: 4,
    bath: 2,
    btn_link: "/booked-prop-details",
  },
  {
    img: "property/grid-five.jpg",
    location: "246 Jalan Putra, Alor Setar",
    priceInRM: 30020,
    price: 124,
    bed: 4,
    bath: 2,
    btn_link: "/booked-prop-details",
  },
  {
    img: "property/grid-six.jpg",
    location: "9806 Jalan Telawi 5, Bangsar Baru",
    priceInRM: 3330020,
    price: 234,
    bed: 4,
    bath: 2,
    btn_link: "/booked-prop-details",
  },
  {
    img: "property/grid-two.jpg",
    location: "Wisma Sesb Jlnt. Abd. Rahman, Kk",
    priceInRM: 31230020,
    price: 535,
    bed: 4,
    bath: 2,
    btn_link: "/booked-prop-details",
  },
  {
    img: "property/grid-four.jpg",
    location: "6B Jalan SS 154B, Subang Jaya",
    priceInRM: 3330020,
    price: 234,
    bed: 4,
    bath: 2,
    btn_link: "/booked-prop-details",
  },
  {
    img: "property/grid-five.jpg",
    location: "Wisma Sesb Jlnt. Abd. Rahman, Kk",
    priceInRM: 30020,
    price: 124,
    bed: 4,
    bath: 2,
    btn_link: "/booked-prop-details",
  },
  {
    img: "property/grid-four.jpg",
    location: "9806 Jalan Telawi 5, Bangsar Baru",
    priceInRM: 3330020,
    price: 234,
    bed: 4,
    bath: 2,
    btn_link: "/booked-prop-details",
  },
  {
    img: "property/grid-two.jpg",
    location: "Wisma Sesb Jlnt. Abd. Rahman, Kk",
    priceInRM: 31230020,
    price: 535,
    bed: 4,
    bath: 2,
    btn_link: "/booked-prop-details",
  },
  {
    img: "property/grid-two.jpg",
    location: "6B Jalan SS 154B, Subang Jaya",
    priceInRM: 3330020,
    price: 654,
    bed: 4,
    bath: 2,
    btn_link: "/booked-prop-details",
  },
  {
    img: "property/grid-two.jpg",
    location: "9806 johar Ave, Nasa City Johar",
    priceInRM: 31230020,
    price: 535,
    bed: 4,
    bath: 2,
    btn_link: "/booked-prop-details",
  },
  {
    img: "property/grid-four.jpg",
    location: "9806 johar Ave, Nasa City Johar",
    priceInRM: 3330020,
    price: 234,
    bed: 4,
    bath: 2,
    btn_link: "/booked-prop-details",
  },
  {
    img: "property/grid-five.jpg",
    location: "9806 johar Ave, Nasa City Johar",
    priceInRM: 30020,
    price: 124,
    bed: 4,
    bath: 2,
    btn_link: "/booked-prop-details",
  },
  {
    img: "property/grid-four.jpg",
    location: "9806 johar Ave, Nasa City Johar",
    priceInRM: 3330020,
    price: 234,
    bed: 4,
    bath: 2,
    btn_link: "/booked-prop-details",
  },
  {
    img: "property/grid-five.jpg",
    location: "9806 johar Ave, Nasa City Johar",
    priceInRM: 30020,
    price: 124,
    bed: 4,
    bath: 2,
    btn_link: "/booked-prop-details",
  },
  {
    img: "property/grid-six.jpg",
    location: "6B Jalan SS 154B, Subang Jaya",
    priceInRM: 3330020,
    price: 234,
    bed: 4,
    bath: 2,
    btn_link: "/booked-prop-details",
  },
];

export default AllCollectionData;
